<template>
  <div class="flexbox-container">
    <div class="row">
      <div class="btn-toolbar col-sm-10 offset-sm-1">
        <div class="col-sm-6">
          <button class="btn btn-primary btn-lg btn-block" @click="selectRoute(1)">常温商品から登録</button>
        </div>
        <div class="col-sm-6">
          <button class="btn btn-success btn-lg  btn-block" @click="selectRoute(2)">冷蔵商品から登録</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'SelectRoute',
    created() {
      this.$parent.title = '';
      this.$parent.imageName = '';
      this.$parent.hasMaintenancne = true;
      this.$parent.showMaintenanceInformation = false;
    },
    methods: {
      selectRoute(routeType) {
        this.$store.dispatch('setRoutes', { routeType: routeType });
        this.$router.push({ name: 'StartCheck' });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn {
    padding: 2rem 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/SelectRoute.vue?66b7722f